import { useIntl } from 'react-intl';

import { useAppSelector } from '@verantos-dev/app-state-base';
import { selectCohortDsl } from '@verantos-dev/app-state-cohort-builder';
import { getFullDslQueryString } from '@verantos-dev/util-cohort-definition-ui-to-dsl';

import { type CohortTranslationProps } from './CohortTranslation';

export const useCohortDefinitionDSLSection = (): CohortTranslationProps => {
  const intl = useIntl();

  const fullCohortDSL = useAppSelector(selectCohortDsl);
  const cohortQueryStrings = fullCohortDSL ? getFullDslQueryString(fullCohortDSL).split('\n') : [];
  const hasQueryStringValues = cohortQueryStrings.some((line) => line.length > 0);

  return {
    title: intl.formatMessage({
      id: 'projects.cohortBuilderPage.cohortDefinitionDSLSection.title',
    }),
    emptyStateMainMessage: intl.formatMessage({
      id: 'projects.cohortBuilderPage.cohortDefinitionDSLSection.noDSLMainMsg',
    }),
    emptyStateSubMessage: intl.formatMessage({
      id: 'projects.cohortBuilderPage.cohortDefinitionDSLSection.noDSLSubMsg',
    }),
    content: hasQueryStringValues
      ? cohortQueryStrings.map((line, index) => <div key={index}>{line}</div>)
      : undefined,
  };
};
